const this_path = 'LAYOUT_'

export const CHANGE_ALERT_LIST = `${this_path}CHANGE_ALERT_LIST`
